import React, { FC, useState, ReactNode } from 'react';
import { styleSizesNumber } from 'constants/styleSizes';
import { useRecoilState } from 'recoil';
import { leavingOfferShowed } from 'states/ModalStates/atoms';
import { BasicScreenContainer, ErrorsAndMessages } from './style';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { useBackToTop } from 'customHooks/useBackToTop';
import { Helmet } from 'react-helmet';
import { createPortal } from 'react-dom';
import AlertMessage from 'components/AlertMessage';
import { globalErrorState, globalMessageState} from 'states/CommonStates/atoms';
import { useLocation } from 'react-router-dom';

import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';

type ScreenLayoutProps = {
  children: ReactNode;
  disableFooter?: boolean;
  disableModal?: boolean;
  disableMap?: boolean;
};

interface Address {
  streetAddress: string;
  addressLocality: string;
  addressRegion: string;
  postalCode: string;
  addressCountry: string;
}

interface Hotel {
  name: string;
  description: string;
  address: Address;
  telephone: string;
  url: string;
}



const hotel: Hotel = {
  name: "Rook Hotel",
  description: "Welcome to Example Hotel, the perfect destination for your stay!",
  address: {
    streetAddress: "3660 Hurontario Street",
    addressLocality: "Mississauga",
    addressRegion: "Ontario",
    postalCode: "L5B 3C4",
    addressCountry: "Canada"
  },
  telephone: "+19059494000",
  url: "https://www.rookhotel.com",
};

const jsonLdScript = `
{
  "@context": "https://schema.org",
  "@type": "Hotel",
  "name": "${hotel.name}",
  "description": "${hotel.description}",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "${hotel.address.streetAddress}",
    "addressLocality": "${hotel.address.addressLocality}",
    "addressRegion": "${hotel.address.addressRegion}",
    "postalCode": "${hotel.address.postalCode}",
    "addressCountry": "${hotel.address.addressCountry}"
  },
  "telephone": "${hotel.telephone}",
  "url": "${hotel.url}",
}
`;

const ScreenLayout: FC<ScreenLayoutProps> = ({ children, disableFooter, disableMap, disableModal }) => {

  const location = useLocation();
  const isAccountRoute = location.pathname.includes('account/');

  useBackToTop();
  const time = Date.now()

  const [offerShowed, setOfferShowed] = useRecoilState(leavingOfferShowed)
  const [, setLeavingModal] = useState(false);
  useState('DADJOKES');

  const leavingOffer = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if(Date.now() > (time + 10000)) {
      if(!offerShowed && window.innerWidth > styleSizesNumber.wideScreenBreakpoint) {
        if (e.clientY <= 0 || (e.movementY < 0 && e.movementY < -e.clientY)) {
          setLeavingModal(true)
          setOfferShowed(true)
        }
      }
    }
  }




  const [errorState] = useRecoilState(globalErrorState);
  const [messageState] = useRecoilState(globalMessageState);
  const { hideGlobalError, hideGlobalMessage } = useGlobalAlerts();


  return (
    <>
      <BasicScreenContainer onMouseLeave={(e) => leavingOffer(e)}>
        <Header />
        {createPortal(
          <ErrorsAndMessages>
            <AlertMessage
              showMessage={errorState.isVisible}
              messageType='error'
              onClose={hideGlobalError}
              hideMessage={errorState.hideMessage}
            >
              {errorState.text}
            </AlertMessage>

            <AlertMessage
              showMessage={messageState.isVisible}
              messageType='message'
              onClose={hideGlobalMessage}
              hideMessage={messageState.hideMessage}
            >
              {messageState.text}
            </AlertMessage>
          </ErrorsAndMessages>,
          document.body
        )}
        <main>{children}</main>
        <Footer 
          disableFooter={disableFooter || isAccountRoute} 
          disableMap={disableMap} 
        />
      </BasicScreenContainer>
      {/* disable this at developing stage temporarily*/}
      {/* <Modal open={disableModal? false:leavingModal}>
        {time% 2? <LeavingModalBodyWhite handleClick={handleClick} close={close} couponId={couponId}/>:<LeavingModalBodyBlack handleClick={handleClick} close={close} couponId={couponId}/>}    
      </Modal> */}
      <Helmet>
        <script type="application/ld+json">
          {jsonLdScript}
        </script>
      </Helmet>
    </>
  );
};

export default ScreenLayout;
